import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="h-screen flex-1 bg-white text-[#10303A]">
      <div className="h-full max-w-4xl mx-auto">
        {/* Área scrolleable */}
        <div className="h-full overflow-y-auto px-6 py-8">
          {/* Header */}
          <h1 className="text-3xl font-bold text-center text-[#5298A8] mb-6">
            Privacy Policy - McNally EV
          </h1>

          {/* Section 1 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            1. Responsible Entity
          </h2>
          <p className="text-sm leading-relaxed">
            This application is managed by <strong>McNally EV</strong>, based in the United Kingdom.
            For any privacy-related questions, you can contact us at{" "}
            <a
              href="mailto:info@mcnallyelectrical.co.uk"
              className="underline text-[#5298A8]"
            >
              info@mcnallyelectrical.co.uk
            </a>{" "}
            or visit our website{" "}
            <a
              href="https://mcnallyev.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-[#5298A8]"
            >
              https://mcnallyev.uk/
            </a>.
          </p>

          {/* Section 2 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            2. Data We Collect
          </h2>
          <p className="text-sm leading-relaxed">
            We may collect the following data: full name, email address, profile photo, phone number,
            notifications, and images uploaded by the user. No payment methods are collected or stored.
          </p>

          {/* Section 3 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            3. Purpose of Data Use
          </h2>
          <p className="text-sm leading-relaxed">
            The collected data is used solely for app functionality, usage analytics, and communication
            with users.
          </p>

          {/* Section 4 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            4. Data Sharing
          </h2>
          <p className="text-sm leading-relaxed">
            We do not sell or share personal information with third parties. However, our application uses
            Firebase services for authentication, storage, and hosting.
          </p>

          {/* Section 5 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            5. Data Retention and Deletion
          </h2>
          <p className="text-sm leading-relaxed">
            Your information is retained as long as your account is active. You may request deletion at any
            time by contacting{" "}
            <a
              href="mailto:info@mcnallyelectrical.co.uk"
              className="underline text-[#5298A8]"
            >
              info@mcnallyelectrical.co.uk
            </a>{" "}
            or through the in-app option.
          </p>

          {/* Section 6 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            6. Security
          </h2>
          <p className="text-sm leading-relaxed">
            We apply strict Firebase security rules and technical measures to protect your information
            from unauthorised access, alteration, or disclosure.
          </p>

          {/* Section 7 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            7. Age Restriction
          </h2>
          <p className="text-sm leading-relaxed">
            This application is intended for users over the age of 17.
          </p>

          {/* Section 8 */}
          <h2 className="text-xl font-semibold text-[#5298A8] mt-5 mb-2">
            8. Policy Updates
          </h2>
          <p className="text-sm leading-relaxed">
            We reserve the right to update this policy. Any changes will be notified within the app or via this website.
          </p>

          {/* Last Updated */}
          <p className="text-xs text-right text-[#5298A8] mt-8 italic">
            Last updated: 28 August 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;